import React from "react";
import { WrapStyle } from "./styles";

const CreateDocumentFormFooter = ({
  children,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>) => {
  return <WrapStyle {...rest}>{children}</WrapStyle>;
};

export default CreateDocumentFormFooter;
